import React from 'react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-white">
      {/* Sección superior con fondo blanco y forma de onda */}
      <div className="relative">
        {/* Forma de onda decorativa */}
        <div className="absolute top-0 left-0 w-full h-8 bg-gradient-to-b from-blue-50 to-white"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Sección Join Dash AI */}
            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-gray-900">Join Dash AI</h3>
              <p className="text-gray-600">Receive pricing updates, shopping tips & more!</p>
              
              <div className="flex flex-col sm:flex-row gap-3">
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
                  <input
                    type="email"
                    placeholder="Enter your email"
                    className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
                <button className="bg-blue-600 text-white px-6 py-3 rounded-md font-medium hover:bg-blue-700 transition-colors duration-200 whitespace-nowrap">
                  Sign Up
                </button>
              </div>

              {/* Sección Follow Us */}
              <div className="mt-8">
                <h4 className="text-lg font-semibold text-gray-900 mb-3">Follow Us</h4>
                <div className="flex space-x-4">
                  {/* YouTube */}
                  <a href="#" className="text-gray-600 hover:text-gray-900 transition-colors duration-200">
                    <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                    </svg>
                  </a>
                  
                  {/* Instagram */}
                  <a href="#" className="text-gray-600 hover:text-gray-900 transition-colors duration-200">
                    <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 6.62 5.367 11.987 11.988 11.987 6.62 0 11.987-5.367 11.987-11.987C24.014 5.367 18.637.001 12.017.001zM8.449 16.988c-1.297 0-2.448-.49-3.323-1.297C4.198 14.895 3.708 13.744 3.708 12.447s.49-2.448 1.297-3.323c.875-.807 2.026-1.297 3.323-1.297s2.448.49 3.323 1.297c.807.875 1.297 2.026 1.297 3.323s-.49 2.448-1.297 3.323c-.875.807-2.026 1.297-3.323 1.297zm7.83-9.281c-.49 0-.98-.49-.98-.98s.49-.98.98-.98.98.49.98.98-.49.98-.98.98z"/>
                    </svg>
                  </a>
                  
                  {/* TikTok */}
                  <a href="#" className="text-gray-600 hover:text-gray-900 transition-colors duration-200">
                    <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
                    </svg>
                  </a>
                  
                  {/* LinkedIn */}
                  <a href="#" className="text-gray-600 hover:text-gray-900 transition-colors duration-200">
                    <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                    </svg>
                  </a>
                  
                  {/* Facebook */}
                  <a href="#" className="text-gray-600 hover:text-gray-900 transition-colors duration-200">
                    <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                    </svg>
                  </a>
                  
                  {/* X (Twitter) */}
                  <a href="#" className="text-gray-600 hover:text-gray-900 transition-colors duration-200">
                    <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                    </svg>
                  </a>
                  
                  {/* RSS */}
                  <a href="#" className="text-gray-600 hover:text-gray-900 transition-colors duration-200">
                    <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M4.259 3.09c-1.61 0-2.913 1.303-2.913 2.913s1.303 2.913 2.913 2.913 2.913-1.303 2.913-2.913-1.303-2.913-2.913-2.913zm0 4.259c-.741 0-1.346-.605-1.346-1.346s.605-1.346 1.346-1.346 1.346.605 1.346 1.346-.605 1.346-1.346 1.346zm6.259 1.346c0-5.841-4.741-10.582-10.582-10.582S-4.741 2.844-4.741 8.685c0 5.841 4.741 10.582 10.582 10.582s10.582-4.741 10.582-10.582zm-10.582 9.259c-4.787 0-8.675-3.888-8.675-8.675s3.888-8.675 8.675-8.675 8.675 3.888 8.675 8.675-3.888 8.675-8.675 8.675z"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>

            {/* Sección Download the app */}
            <div className="space-y-4">
              <div className="flex justify-between items-start">
                <h3 className="text-lg font-semibold text-gray-900">Download the Dash AI app</h3>
                <button 
                  onClick={scrollToTop}
                  className="text-blue-600 hover:text-blue-800 transition-colors duration-200 flex items-center space-x-1 border border-blue-600 px-3 py-1 rounded-md"
                >
                  <span>Back to Top</span>
                  <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
                  </svg>
                </button>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-3">
                {/* App Store Badge */}
                <a href="#" className="inline-flex items-center bg-black text-white px-4 py-3 rounded-md hover:bg-gray-800 transition-colors duration-200">
                  <svg className="h-6 w-6 mr-2" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.11-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                  </svg>
                  <div className="text-left">
                    <div className="text-xs">Download on the</div>
                    <div className="text-sm font-semibold">App Store</div>
                  </div>
                </a>
                
                {/* Google Play Badge */}
                <a href="#" className="inline-flex items-center bg-black text-white px-4 py-3 rounded-md hover:bg-gray-800 transition-colors duration-200">
                  <svg className="h-6 w-6 mr-2" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                  </svg>
                  <div className="text-left">
                    <div className="text-xs">GET IT ON</div>
                    <div className="text-sm font-semibold">Google Play</div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sección inferior con fondo gris */}
      <div className="bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          {/* Enlaces de navegación */}
          <div className="flex flex-wrap gap-4 text-sm text-gray-600 mb-4">
            <a href="#" className="hover:text-gray-900 underline">Contact Us</a>
            <a href="#" className="hover:text-gray-900 underline">Careers</a>
            <a href="#" className="hover:text-gray-900 underline">Your Ad Choices</a>
            <a href="#" className="hover:text-gray-900 underline">Privacy Statement</a>
            <a href="#" className="hover:text-gray-900 underline">Visitor Agreement</a>
            <a href="#" className="hover:text-gray-900 underline">Accessibility</a>
            <a href="#" className="hover:text-gray-900 underline">Do Not Sell or Share My Personal Information</a>
            <a href="#" className="hover:text-gray-900 underline">Dash AI Information</a>
          </div>
          
          {/* Copyright */}
          <p className="text-xs text-gray-600 leading-relaxed">
            © Dash AI, Inc., a wholly owned subsidiary of CarMax, Inc. By using dashai.com, you consent to the monitoring and storing of your interactions with the website, including by a Dash AI vendor, for use in improving and personalizing our services. See our Privacy Statement for details.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
